// extracted by mini-css-extract-plugin
var _1 = "BlockHistory_active__8e71c";
var _2 = "BlockHistory_avatar__1983e";
var _3 = "BlockHistory_blockPreview__1c1f2";
var _4 = "BlockHistory_button__9834f";
var _5 = "BlockHistory_date__5c252";
var _6 = "BlockHistory_history__dc870";
var _7 = "BlockHistory_historyList__d2297";
var _8 = "BlockHistory_icon__57bb1";
var _9 = "BlockHistory_panel__32724";
var _a = "BlockHistory_release__1b3b0";
var _b = "BlockHistory_root__f601e";
var _c = "BlockHistory_title__1dcff";
var _d = "BlockHistory_version__d9031";
var _e = "BlockHistory_versionName__e4ec1";
export { _1 as "active", _2 as "avatar", _3 as "blockPreview", _4 as "button", _5 as "date", _6 as "history", _7 as "historyList", _8 as "icon", _9 as "panel", _a as "release", _b as "root", _c as "title", _d as "version", _e as "versionName" }
